<button mat-icon-button (click)="onClick()">
  <mat-icon class="share-icon">send</mat-icon>
</button>
